import React, { useState } from 'react';
import { connect } from 'react-redux';

import clsx from 'clsx';

import BobConfirmButton from '../../../components/BobConfirmButton';
import BobCancelButton from '../../../components/BobCancelButton';
import BobModal from '../../../components/BobModal';

import * as ErpAgentActions from '../../../actions/erpAgentActions';

import * as classes from './ResetAuthKeyModal.module.css';

const ResetAuthKeyModal = ({
    integration,
    rotateErpAgentCredentials,
    setResetAuthKeyModalOpen,
    ...props
}) => {

    const [isLoading, setIsLoading] = useState(false);

    const handleRotateCredentials = async () => {
        const agentId = integration.id;

        setIsLoading(true);
        await rotateErpAgentCredentials(agentId);
        setIsLoading(false);
    };

    return (
        <BobModal
            title={'Reset Authorization Key'}
            hidebuttons={true}
            headerOverride={classes.HeaderOverride}
            isRemoveFooter={true}
            onClose={() => setResetAuthKeyModalOpen(false)}
        >
            <div className={classes.ModalBody}>
                <div className={classes.NamePanel}>
                    <div className={classes.Title}>
                        Integration Name
                    </div>
                    <div className={classes.IntegrationName}>
                        {integration.name}
                    </div>
                </div>
                <div className={classes.InfoPanel}>
                    <i className={clsx('fas fa-info-circle', classes.HelpIcon)} />
                    <span className={classes.InfoText}>
                        Rotating Integration Credentials will delete the current Integration Authorization Key and generate a new one.
                        The FSM Integration using current credentials will require the newly generated authorization key to be applied to the FSM Integration software.
                    </span>
                </div>
                <div className={classes.ConfirmationPanel}>
                    Are you sure you want to reset the authorization key?
                </div>
                <div className={classes.ButtonPanel}>
                    <BobCancelButton
                        disabled={isLoading}
                        onClick={() => setResetAuthKeyModalOpen(false)}
                        className={classes.CancelButton}
                        label={'No'}
                    />
                    <BobConfirmButton
                        onClick={() => handleRotateCredentials()}
                        className={classes.Buttons}
                        label={'Yes'}
                        iconSize={15}
                        isLoading={isLoading}
                    />
                </div>
            </div>
        </BobModal>
    );
};

const mapDispatchToProps = {
    ...ErpAgentActions
};

export default connect(null, mapDispatchToProps)(ResetAuthKeyModal);
